import { ReactNode } from "react";
import "./textwithurl.scss";

type TextWithUrlProps = {
  mainContent: string | ReactNode;
};
export default function TextWithUrl({ mainContent }: TextWithUrlProps) {
  const renderWithUrls = (content: string): React.ReactNode => {
    // Regular expression to match URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return content.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        // If part is a URL, wrap it in an <a> tag
        return (
          <a
            key={index}
            href={part}
            className="word-break"
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <>
      {typeof mainContent === "string"
        ? renderWithUrls(mainContent)
        : mainContent}
    </>
  );
}
